export const SUCCESS = "SUCCESS"
export const ERROR = "ERROR"
